module.exports = __webpack_public_path__ + "img/pic_watch2@2x.0145bd66.png";